import { render } from "./Accounts.vue?vue&type=template&id=6441ad22"
import script from "./Accounts.vue?vue&type=script&lang=js"
export * from "./Accounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__